import { useHistory } from 'react-router-dom';

import { useMutation } from 'react-query';

import { useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';

import { createTicket } from '@services/queries/tickets';

import { useCreateTicketState } from '@store/hookstate';

import {
  Container,
  Input,
  Label,
  Textbox,
  Attachments,
  Bottom,
  Button,
  Left,
} from './TicketForm.styles';

interface IFormData {
  title: string;
  description: string;
}

const TicketForm = () => {
  const history = useHistory();

  const createTicketState = useCreateTicketState();

  const mutationCreateTicket = useMutation(createTicket, {
    onSuccess: () => {
      createTicketState.closeCreateTicket();
      history.push('/tickets');
    },
  });

  const schema = yup.object().shape({
    title: yup.string().required(),
    description: yup.string().required(),
  });

  const { register, handleSubmit } = useForm<IFormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: IFormData) => {
    mutationCreateTicket.mutate({
      title: data.title,
      description: data.description,
      type: 'internal',
      status: 'open',
      equipmentId: createTicketState.equipmentId.get(),
    });
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Label>Title</Label>
        <div style={{ height: 8 }} />
        <Input {...register('title')} />

        <div style={{ height: 16 }} />
        <Label>Description</Label>

        <div style={{ height: 8 }} />
        <Textbox {...register('description')} />
        <div style={{ height: 25 }} />
        <Bottom>
          <Left>
            <Label>Attachments</Label>
            <div style={{ width: 16 }} />
            <Attachments>Add</Attachments>
          </Left>

          <div style={{ width: 16 }} />
          <Button type="submit">Send</Button>
        </Bottom>
      </form>
    </Container>
  );
};

export { TicketForm };
